import {
	RECEIVE_PROFILE_DATA,
	REQUEST_PROFILE_DATA,
	REQUEST_PROFILE_DATA_UPDATE,
} from "./actions";
import { RECEIVE_ERRORS } from "../alerts/errors/actions";

export function profileReducer(profileId) {
	const initialState = {
		id: profileId,
		loading: true,
		success: false,
	};

	return function (state = initialState, action) {
		switch (action.type) {
			case RECEIVE_PROFILE_DATA:
			case RECEIVE_ERRORS: {
				return Object.assign({}, state, {
					loading: false,
				});
			}
			case REQUEST_PROFILE_DATA:
				return Object.assign({}, state, {
					loading: true,
				});
			case REQUEST_PROFILE_DATA_UPDATE: {
				return Object.assign({}, state, {
					loading: true,
				});
			}
			default:
				return state;
		}
	};
}
